import { Stack, Box, Text, Divider } from 'braid-design-system';

import React, { type ReactElement, useState } from 'react';
import { observer } from 'mobx-react';
import TextButton from 'src/components/common/TextButton';
import translations from './.vocab/';
import { useTranslations } from '@vocab/react';

interface DisplayValue {
  value?: string;
  alt?: string;
}

interface Props {
  editable: boolean;
  children: ReactElement;
  displayValues?: DisplayValue[];
  onEditClickTracking?: any | undefined;
}

const FormStep = ({
  editable,
  children,
  displayValues = [],
  onEditClickTracking,
}: Props) => {
  const [isInManualEditMode, setIsInManualEditMode] = useState(false);
  const { t } = useTranslations(translations);
  const onEditClick = () => {
    if (onEditClickTracking) {
      onEditClickTracking();
    }
    setIsInManualEditMode(true);
  };
  return (
    <>
      {editable || isInManualEditMode ? (
        <Stack space="medium">
          {children}
          {isInManualEditMode && (
            <Stack space="medium">
              <Box width="full" textAlign="right">
                <Text>
                  <TextButton
                    data-testid="add-candidate-form-step-update"
                    onClick={() => setIsInManualEditMode(false)}
                  >
                    {t('Update')}
                  </TextButton>
                </Text>
              </Box>
              <Box paddingTop="xsmall" paddingBottom="xsmall">
                <Divider />
              </Box>
            </Stack>
          )}
        </Stack>
      ) : (
        <Stack space="xsmall">
          <Box
            width="full"
            display="flex"
            justifyContent="spaceBetween"
            alignItems="flexEnd"
            paddingTop="xsmall"
            paddingBottom="small"
          >
            <Stack
              space="medium"
              data={{ testid: 'add-candidate-form-step-display' }}
            >
              {displayValues.map((item, index) => (
                <Text
                  key={index}
                  weight="medium"
                  tone={item.value ? 'neutral' : 'secondary'}
                  size={item.value ? 'standard' : 'small'}
                >
                  {item.value
                    ? item.value
                    : t('itemAlt not provided', { itemAlt: item.alt ?? '' })}
                </Text>
              ))}
            </Stack>

            <Text>
              <TextButton
                data-testid="add-candidate-form-step-edit"
                onClick={onEditClick}
              >
                {t('Edit')}
              </TextButton>
            </Text>
          </Box>
          <Box paddingTop="xsmall" paddingBottom="xsmall">
            <Divider />
          </Box>
        </Stack>
      )}
    </>
  );
};

export default observer(FormStep);
